<script setup lang="ts">
const props = defineProps<{
  items: {
    _id: string
    display: string
    selected: boolean
    icon?: any
  }[]
  dataCy?: string
}>()

const emits = defineEmits<{
  'update:items': [value: {
    _id: string
    display: string
    selected: boolean
    icon?: any
  }]
}>()
</script>

<template>
  <div class="w-full flex gap-2 flex-wrap">
    <div
      v-for="item in props.items" :key="item._id"
      :class="{ 'border border-primary-400! dark:bg-primary-800/60 bg-primary-500 text-white': item.selected }"
      class="p-2 bg-base transition-colors cursor-pointer rounded-xl border border-base flex flex-col gap-2 items-center justify-center grow"
      @click="emits('update:items', item)"
      :data-cy="`choice-option-${props.dataCy?props.dataCy:'value'}-${item._id}`"
    >
      <component :is="item.icon" class="text-4xl" />
      <p>{{ item.display }}</p>
    </div>
  </div>
</template>
